"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerminalControlPaymentWithPayloadSerialization = void 0;
const PaymentTerminalControlEMVCardPayloadSerialization_1 = require("./PaymentTerminalControlEMVCardPayloadSerialization");
const PaymentTransactionSerialization_1 = require("./PaymentTransactionSerialization");
class PaymentTerminalControlPaymentWithPayloadSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.payment_transaction = entity.payment_transaction
            ? JSON.parse(PaymentTransactionSerialization_1.PaymentTransactionSerialization.serialize(entity.payment_transaction))
            : undefined;
        copy.card_payload = entity.card_payload
            ? JSON.parse(PaymentTerminalControlEMVCardPayloadSerialization_1.PaymentTerminalControlEMVCardPayloadSerialization.serialize(entity.card_payload))
            : undefined;
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.payment_transaction = entity.payment_transaction
            ? PaymentTransactionSerialization_1.PaymentTransactionSerialization.deserialize(JSON.stringify(entity.payment_transaction))
            : undefined;
        copy.card_payload = entity.card_payload
            ? PaymentTerminalControlEMVCardPayloadSerialization_1.PaymentTerminalControlEMVCardPayloadSerialization.deserialize(JSON.stringify(entity.card_payload))
            : undefined;
        return copy;
    }
}
exports.PaymentTerminalControlPaymentWithPayloadSerialization = PaymentTerminalControlPaymentWithPayloadSerialization;
